import _InputCurrency from './_InputCurrency'
import _InputDate from './_InputDate'
import _InputImage from './_InputImage'
import _InputImageGallery from './_InputImageGallery'
import _InputMask from './_InputMask'
import _InputPassword from './_InputPassword'
import _InputRadio from './_InputRadio'
import _InputSelect from './_InputSelect'
import _InputSwitch from './_InputSwitch'
import _InputText from './_InputText'
import _InputTextArea from './_InputTextarea'

// prettier-ignore
export const Inputs = {
  Currency:     _InputCurrency,
  Date:         _InputDate,
  Image:        _InputImage,
  ImageGallery: _InputImageGallery,
  Mask:         _InputMask,
  Password:     _InputPassword,
  Radio:        _InputRadio,
  Select:       _InputSelect,
  Switch:       _InputSwitch,
  Text:         _InputText,
  Textarea:     _InputTextArea,
};
